import { render, staticRenderFns } from "./ReportPublic.vue?vue&type=template&id=70c899e1"
import script from "./ReportPublic.vue?vue&type=script&lang=js"
export * from "./ReportPublic.vue?vue&type=script&lang=js"
import style0 from "./ReportPublic.vue?vue&type=style&index=0&id=70c899e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports